import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import LinkButton from 'flarum/common/components/LinkButton';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
import IndexPage from 'flarum/forum/components/IndexPage';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import fullTime from 'flarum/common/helpers/fullTime';
import m from 'mithril';
/**
 * The `PageHero` component displays the hero on a page page.
 *滚动发帖按钮
 * ### Props
 *
 * - `page`
 */
export default class FloatPostButton extends Component {
  view() {
    let user = app.session.user;
    const canStartDiscussion = app.forum.attribute('canStartDiscussion') || !user || (user && !user.isSuspended());
    
    return (
      <Button 
      className="floatingImageContainer" 
      onclick={() => {
      if(!canStartDiscussion) {
        let util = user?.suspendedUntil();
          if (util) {
            const timespan = AlertUtil.isPermanentSuspensionDate(new Date(util))
            let date = fullTime(util);
            AlertUtil.onSuccess(app, app.translator.trans(`dl-index.forum.confirm_messages.${timespan ? 'all' : 'already'}_suspend_user`,{util:date}))
            return;
          }
        }
        return IndexPage.prototype.newDiscussionAction().catch(() => {});
      }}
        // disabled={!canStartDiscussion}
      >
        <img src={`${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/btm-ftie.png`} alt="Floating Image" className="floatingImage" />
      </Button>
    );
  }

}
